import type { FaireProductEntity } from "../../entity_types/product";

export const p_9r9ut3ra4j: FaireProductEntity = {
  token: "p_9r9ut3ra4j",
  type: "product",
  name: "AUNT VIV - A Portrait Candle",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/deba4806eed7bcc2123a8c6d6ab0a1b7b03d5af3bad99aa1c2a76555141a48fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2aa1f65aeff14e63c603515f4ac21108bb7dc543d451243bb9d432855748acbd.jpeg"
  ],
  priceDollars: 13.2,
  description: "We're thrilled to introduce our latest creation, Aunt Viv, inspired by our cafe’s specialty house drink. This candle embodies warmth and comfort with its delightful blend of cardamom and cream. Each pour is done with precision and care, ensuring that every candle brings joy and warmth to your space. Experience the soothing ambiance of Aunt Viv—perfect for those moments when you want to unwind and create a haven of comfort in your home.\n\n\nPro tips: \n\n1. For an even burn, trim your wick down to 1/4 inch before each use (trust us, your candle will produce a more fragrant scent!) \n2. To avoid tunneling, upon first light wait at least three hours or until the candle wax has melted evenly upon the first burn.\n\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:45.522Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
